import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryNav() {
  const colorMap: Record<string, { bg: string; iconBg: string; text: string }> = {
    primary: { bg: 'bg-primary-100/70', iconBg: 'bg-primary-100', text: 'text-primary-700' },
    secondary: { bg: 'bg-secondary-100/70', iconBg: 'bg-secondary-100', text: 'text-secondary-700' },
    accent: { bg: 'bg-accent-100/70', iconBg: 'bg-accent-100', text: 'text-accent-700' },
  };

  const catImages: Record<string, string> = {
    'newborn-care': 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20illustration%20of%20newborn%20baby%20essentials%20in%20warm%20pastel%20cream%20tones%2C%20baby%20care%20items%20arranged%20aesthetically%2C%20clean%20simple%20composition%2C%20gentle%20nurturing%20vibe&width=400&height=300&seq=cat-newborn-02&orientation=landscape',
    'postpartum-recovery': 'https://readdy.ai/api/search-image?query=Serene%20minimalist%20illustration%20of%20wellness%20and%20self%20care%20with%20soft%20sage%20green%20and%20cream%20palette%2C%20gentle%20yoga%20elements%2C%20calm%20healing%20atmosphere%2C%20clean%20simple%20aesthetic&width=400&height=300&seq=cat-postpartum-02&orientation=landscape',
    'breastfeeding': 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20illustration%20of%20motherhood%20nursing%20essentials%20in%20soft%20golden%20and%20cream%20tones%2C%20gentle%20nurturing%20elements%2C%20clean%20simple%20composition%2C%20intimate%20caring%20atmosphere&width=400&height=300&seq=cat-breastfeeding-02&orientation=landscape',
    'early-education': 'https://readdy.ai/api/search-image?query=Playful%20minimalist%20illustration%20of%20baby%20educational%20toys%20in%20soft%20pastel%20coral%20and%20cream%20tones%2C%20montessori%20inspired%20elements%2C%20clean%20simple%20aesthetic%2C%20joyful%20learning%20atmosphere&width=400&height=300&seq=cat-education-02&orientation=landscape',
    'mom-growth': 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20illustration%20of%20personal%20growth%20and%20self%20development%20in%20warm%20golden%20and%20cream%20tones%2C%20journal%20and%20plant%20elements%2C%20clean%20simple%20composition%2C%20inspiring%20uplifting%20atmosphere&width=400&height=300&seq=cat-growth-02&orientation=landscape',
  };

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 -mt-16 relative z-20">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => {
          const colors = colorMap[cat.color] || colorMap.primary;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden cursor-pointer bg-white h-[140px] md:h-[180px]"
            >
              <img
                src={catImages[cat.slug]}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg ${colors.iconBg}/90 flex items-center justify-center mb-1.5`}>
                  <i className={`${cat.icon} ${colors.text} text-sm md:text-base`}></i>
                </div>
                <h3 className="text-white font-semibold text-sm md:text-base whitespace-nowrap">{cat.name}</h3>
                <p className="text-white/70 text-xs mt-0.5 hidden sm:block">{cat.description}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}